import React from "react";

import { format, FormatOptions } from "date-fns";
import { enUS } from "date-fns/locale/en-US";

import CountryCode from "@mapmycustomers/shared/enum/CountryCode";
import FieldCategory from "@mapmycustomers/shared/enum/fieldModel/FieldCategory";
import FindMyResultReturnValue from "@mapmycustomers/shared/types/FindMyResultReturnValue";
import { UserRef } from "@mapmycustomers/shared/types/User";

import IConfigProviderContext, { FormatNumberOptions } from "../types/IConfigProviderContext";

import defaultCountryNameFormatter from "./defaultCountryNameFormatter";
import defaultMessageFormatter from "./defaultMessageFormatter";
import getDecimalSeparator from "./getDecimalSeparator";

const ConfigProviderContext = React.createContext<IConfigProviderContext>({
  complementFileUrl(url?: null | string): string | undefined {
    return this.complementFileUrl(url);
  },
  currencies: [],
  dateFnsLocale: enUS,
  defaultCurrencyCode: 103,
  formatCountryName(countryCode: CountryCode): string {
    return defaultCountryNameFormatter(countryCode);
  },
  formatDate(date: Date | number | string, formatStr: string, options?: FormatOptions) {
    return format(date, formatStr, { locale: enUS, ...options });
  },
  formatMessage: defaultMessageFormatter,
  formatNumber(
    value: Parameters<Intl.NumberFormat["format"]>[0],
    opts?: FormatNumberOptions
  ): string {
    console.warn(
      `[ConfigProvider] Please provide a number formatter, currently using a default one with locales "${navigator.languages.join(
        ", "
      )}", which might be incorrect`
    );
    const intl = Intl.NumberFormat([...navigator.languages], opts);
    return intl.format(value);
  },
  getDecimalSeparator(): string {
    console.warn(
      `[ConfigProvider] Please provide decimal separator getter, currently using a default one with locale ${navigator.language}, which might be incorrect`
    );
    return getDecimalSeparator(navigator.language);
  },
  getFieldCategoryDisplayName: function (fieldCategory: FieldCategory): string {
    return fieldCategory;
  },
  getUserColorClassName(user: UserRef): string | undefined {
    return this.getUserColorClassName(user);
  },
  useFindMyLocation(): FindMyResultReturnValue {
    return ["", () => {}, false, undefined, () => {}, undefined, () => {}];
  },
});

export default ConfigProviderContext;
